<div class="dialog-content">
  <h2 mat-dialog-title>Script Submission Failed</h2>
  <mat-dialog-content>
    <div class="error-icon-container">
      <app-icon icon="error" class="error-main-icon"></app-icon>
    </div>
    
    <p class="error-message-text">{{ data.message }}</p>
    
    <div class="errors-container">
      <h3 class="errors-title-text">Validation Errors:</h3>
      <div class="error-list">
        @if (data.errorMessages && data.errorMessages.length > 0) {
          @for (error of data.errorMessages; track $index) {
            <div class="error-item">
              <mat-icon class="error-icon">error_outline</mat-icon>
              <span>{{ error }}</span>
            </div>
          }
        } @else if (data.errors) {
          <div class="error-item">
            <mat-icon class="error-icon">error_outline</mat-icon>
            <span [innerHTML]="data.errors"></span>
          </div>
        } @else {
          <div class="error-item">
            <mat-icon class="error-icon">error_outline</mat-icon>
            <span>{{ data.message }}</span>
          </div>
        }
      </div>
    </div>
    
    <div class="copy-section">
      <p class="copy-instructions">
        You can copy all error messages to share with support or keep for reference:
      </p>
      <mat-form-field appearance="outline" class="copy-textarea-field">
        <mat-label>Error Messages (Click to copy)</mat-label>
        <textarea 
          matInput 
          [value]="errorText" 
          readonly 
          rows="6"
          class="copy-textarea"
          (click)="copyErrors()">
        </textarea>
        <button 
          mat-icon-button 
          matSuffix 
          (click)="copyErrors()" 
          [class.copied]="copied"
          title="Copy all errors">
          <mat-icon>{{ copied ? 'check' : 'content_copy' }}</mat-icon>
        </button>
      </mat-form-field>
      @if (copied) {
        <p class="copied-message">
          <mat-icon class="copied-icon">check_circle</mat-icon>
          Copied to clipboard!
        </p>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
</div>

